import { render, staticRenderFns } from "./AccountingEntries.vue?vue&type=template&id=ddb28f10&scoped=true"
import script from "./AccountingEntries.vue?vue&type=script&lang=js"
export * from "./AccountingEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb28f10",
  null
  
)

export default component.exports